import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { EmailLogModel } from "../../apis/ApisEmailLog";
import { ExpanderLogicButton } from "./Shared/ExpanderLogicButton";

export type EmailLogRowProps = {
    log: EmailLogModel,
    showMailto: boolean
}

export function EmailLogRow(props: EmailLogRowProps) {
    let date = new Date(props.log.DateAndTime);
    let dateID = `${date.getFullYear()}_${date.getMonth()}_${date.getDay()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}_${date.getMilliseconds()}`;

    const [openState, setOpenState] = useState<boolean>(false);

    return <Fragment key={`${props.log.FromAddress}_${props.log.Subject}_${dateID}`}>
        <tr className={`${openState ? "bottom-secondary-border bg-lightgrey" : " "}`}>
            <td title={props.log.FromAddress}>
                {props.log.FromAddress.length > 20 ? props.log.FromAddress : props.log.FromAddress.substring(0, 20)}

                {(props.log.Sender ?? "").length > 0 && <span className="ms-2"><i>on behalf of {props.log.Sender.length > 20 ? props.log.Sender : props.log.Sender.substring(0, 20)}</i></span>}
            </td>
            <td>{props.log.Subject}</td>
            <td>{new Date(props.log.DateAndTime).toDateString()}</td>
            {props.showMailto && <td>
                {(props.log.SenderProxyAddress ?? "").length > 0 &&
                    <a className="alt-link" href={`mailto:${props.log.SenderProxyAddress}?subject=${props.log.Subject.startsWith("Re:") ? props.log.Subject : ("Re:" + props.log.Subject)}`}>reply</a>
                } </td>}
            <td className="col-fit-content">
                <ExpanderLogicButton toggled={() => setOpenState(!openState)} targetId={dateID} isOpen={openState} /> </td>
        </tr>
        <tr className={`collapse show-new-line table-collapse pt-0 bottom-grey-border-light`} id={`bdyCollapse_${dateID}`}>
            <td className="table-last-padding pt-0" colSpan={props.showMailto ? 5 : 4}>
                <div className="bg-lightgrey p-3 email-expanded-body" dangerouslySetInnerHTML={{ __html: props.log.Body }}></div></td>
        </tr>
    </Fragment>
}